import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const AboutDescription = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Stack
                position='relative'
                direction='column'
                justifyContent='center'
                alignItems='center'
                className="bodySpacing"
            >
                {/* Upper cloud */}
                <Box
                    sx={{
                        width: '100%',
                        zIndex: 1,
                        backgroundColor: theme.palette.primary.main
                    }}
                >
                    <img 
                        src='/images/vectors/wave bg 2.png' 
                        alt='cloud' 
                        width='100%' 
                        style={{
                            transform: 'translateY(6px)'
                        }}
                    />
                </Box>

                <Box 
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        py: 10
                    }}
                    className='bodyPadding'
                >
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: {xs: 12, md: 14, lg: 16},
                            textAlign: 'center'
                        }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                        >
                            {t('about.we')}
                    </Typography>
                </Box>

                {/* Lower cloud */}
                <Box
                    sx={{
                        width: '100%',
                        zIndex: 1,
                        backgroundColor: theme.palette.primary.main,
                        transform: 'scaleY(-1)'
                    }}
                >
                    <img 
                        src='/images/vectors/wave bg 2.png' 
                        alt='cloud' 
                        width='100%' 
                        style={{
                            transform: 'translateY(6px)'
                        }}
                    />
                </Box>
            </Stack>
        </>
    );
}

export default AboutDescription;